import { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";

import SuspenseLoader from "src/components/SuspenseLoader";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Orders = Loader(lazy(() => import("src/content/orders")));

const orderRoutes = [
  {
    path: "/",
    element: (
      <>
        <Helmet>
          <title> Siparişler </title>
        </Helmet>
        <Orders />
      </>
    ),
  },
  {
    path: "/loom-test",
    element: (
      <>
        <Helmet>
          <title> Loom Test </title>
        </Helmet>
        <Orders />
      </>
    ),
  },
];

export default orderRoutes;
